import { render, staticRenderFns } from "./JobListItem.vue?vue&type=template&id=520a37ee&scoped=true&"
import script from "./JobListItem.vue?vue&type=script&lang=js&"
export * from "./JobListItem.vue?vue&type=script&lang=js&"
import style0 from "./JobListItem.vue?vue&type=style&index=0&id=520a37ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520a37ee",
  null
  
)

export default component.exports